import React, { useState, useEffect } from "react";

import ReportModal from "./ReportModal";

import { RequestState } from "../../utils/RequestState";
import { postReport } from "../../services/api/user/postReport";
import { useAppSelector } from "../../redux/hooks";
import { getEmail, getName } from "../../redux/reducers/user";

type Props = {
  chatPartners: Array<{ id: string; name: string }>;
  modalHandler: () => void;
};

const ReportModalContainer: React.FC<Props> = ({
  chatPartners,
  modalHandler,
}) => {
  const name = useAppSelector(getName);
  const email = useAppSelector(getEmail);
  const [target, setTarget] = useState<
    { id: string; name: string } | undefined
  >(chatPartners.length === 1 ? chatPartners[0] : undefined);
  const [message, setMessage] = useState<string>("");

  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const [error, setError] = useState<boolean>(false);

  const modalSubmitHandler = async () => {
    if (!message) {
      setError(true);
    }

    if (name && email && message && target) {
      setRequestState(RequestState.Doing);

      const res = await postReport(name, email, target.name, message);

      if (res) {
        setRequestState(RequestState.Success);
        setMessage("");
        setTarget(undefined);
      } else {
        setRequestState(RequestState.Failed);
      }
    }
  };

  useEffect(() => {
    if (message) {
      setError(false);
    }
  }, [message]);

  return (
    <ReportModal
      modalHandler={modalHandler}
      handleSubmit={modalSubmitHandler}
      chatPartners={chatPartners}
      target={target}
      setTarget={setTarget}
      setMessage={setMessage}
      requestState={requestState}
      error={error}
    />
  );
};

export default ReportModalContainer;
